import { NgModule, Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'decodeBase64',
    standalone: false
})
export class DecodeBase64Pipe implements PipeTransform {

    decode(str) {
        try {
            return decodeURIComponent(Array.prototype.map.call(atob(str), function(c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));
        } catch (e) {
            return '';
        }
    }

    transform(text: string, solrField?: string) {
        if (!text || solrField && !(solrField.endsWith('_base64') || solrField.endsWith('_lg'))) return text || '';
       return this.decode(text);
    }

}

@NgModule({
    declarations: [DecodeBase64Pipe],
    exports: [DecodeBase64Pipe],
})
export class DecodeBase64PipeModule {}
